(() => {
  if (window.pxReferenceChrome) return;
  window.pxReferenceChrome = true;
  const mobile = matchMedia('(max-width: 1024px)');
  const footerMobile = matchMedia('(max-width: 767px)');
  // The desktop theme scrolls inside .page-wrapper; sticky belongs to #header-group.
  // Measure the real announcement height so localization/wrapping cannot hide nav text.
  const headerGroup = document.querySelector('#header-group');
  const announcement = headerGroup?.querySelector('.px-announcement');
  const updateAnnouncementHeight = () => {
    headerGroup?.style.setProperty('--px-announcement-height', `${announcement?.getBoundingClientRect().height || 0}px`);
  };
  updateAnnouncementHeight();
  if (announcement && 'ResizeObserver' in window) new ResizeObserver(updateAnnouncementHeight).observe(announcement);
  const initialise = (root = document) => {
    root.querySelectorAll('.px-footer-disclosure').forEach((item) => {
      item.open = !footerMobile.matches;
    });
    root.querySelectorAll('[data-px-mega]').forEach((menu) => {
      if (menu.dataset.pxTabsReady) return;
      menu.dataset.pxTabsReady = 'true';
      const tabs = [...menu.querySelectorAll('[data-px-category]')];
      const panels = [...menu.querySelectorAll('[data-px-products]')];
      const select = (tab) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.pxProducts !== tab.dataset.pxCategory; });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') select(tab); });
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('focus', () => select(tab));
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowDown') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(tabs[next]); tabs[next].focus(); }
        });
      });
    });
    root.querySelectorAll('.px-reference-header .px-nav>.px-menu-group').forEach((item) => {
      if (item.dataset.pxHoverReady) return;
      item.dataset.pxHoverReady = 'true';
      item.addEventListener('pointerenter', (event) => {
        if (!mobile.matches && event.pointerType === 'mouse') item.open = true;
      });
      item.addEventListener('pointerleave', (event) => {
        if (!mobile.matches && event.pointerType === 'mouse' && !item.contains(document.activeElement)) item.open = false;
      });
    });
  };
  const closeMenu = () => {
    const menu = document.querySelector('.px-reference-header .px-mobile-nav');
    if (menu?.open) { menu.open = false; menu.querySelector('summary')?.focus(); }
  };
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-px-menu-close]')) closeMenu();
    if (event.target.closest('[data-px-menu-open]')) {
      const menu = document.querySelector('.px-reference-header .px-mobile-nav');
      if (menu) { menu.open = true; menu.querySelector('[data-px-menu-close]')?.focus(); }
    }
    const summary = event.target.closest('.px-footer-disclosure>summary');
    if (summary && !footerMobile.matches) event.preventDefault();
  });
  document.addEventListener('keydown', (event) => {
    const menu = document.querySelector('.px-reference-header .px-mobile-nav[open]');
    if (!menu) return;
    if (event.key === 'Escape') { event.preventDefault(); closeMenu(); }
    if (event.key === 'Tab') {
      const controls = [...menu.querySelectorAll('a,button,summary,input,select')].filter((el) => el.getClientRects().length && !el.disabled);
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  });
  document.addEventListener('toggle', (event) => {
    if (!event.target.matches('.px-reference-header .px-mobile-nav')) return;
    document.documentElement.classList.toggle('px-reference-menu-open', event.target.open);
  }, true);
  footerMobile.addEventListener('change', () => initialise());
  mobile.addEventListener('change', () => { if (!mobile.matches) closeMenu(); });
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  initialise();
})();
